import * as React from "react";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";
import {Types, IFalconPropositionEngine, productHelper, ProductsEnum} from "@falcon/services";
import {Redirect} from "react-router";
import {RetrieveQuoteFailureMessagePage} from "./RetrieveQuoteFailureMessagePage";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";
import * as moment from "moment";

interface IState {
    interaction?: any;
    journey?: any;
    match?: any;
    loadingInteraction?: boolean;
    loadingJourney?: boolean;
}

export class RetrieveQuotePage extends React.Component<IState, IState> {

    @lazyInject(Types.FalconPropositionEngine)
    private propositionEngine: IFalconPropositionEngine;

    private pluginTemplates = new PluginTemplates();

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Quote retrieve");

        this.setState({loadingInteraction: true, loadingJourney: true});

        const product = this.props.match.params.product;
        const process = this.props.match.params.process;
        const interactionId = this.props.match.params.interactionId;
        const languageCode = this.props.match.params.languageCode;
        const email = this.props.match.params.email;
        const dateOfBirth = this.props.match.params.dateOfBirth;

        const decodedProduct: any = productHelper.decodeShortenedProduct(product);

        this.propositionEngine.fetchInteractionByEmailAndDob(decodedProduct, interactionId, email, dateOfBirth).subscribe(
            (interaction: any) => {
                this.setState({interaction, loadingInteraction: false});
                this.propositionEngine.fetchJourneyByInteractionEmailAndDob(decodedProduct, process, interactionId, languageCode, email, dateOfBirth).subscribe(
                    (journey: any) => {
                        this.setState({journey, loadingJourney: false})
                    });
            });
    }

    public render() {
        if (this.state.loadingInteraction || this.state.loadingJourney) {
            return <Overlay show={true}/>
        }

        const {
            interaction,
            journey
        } = this.state;
        if (interaction && interaction.headerInfo && interaction.status && journey) {
            if (moment().isAfter(interaction.headerInfo.expiryDate) || moment().subtract(1, "days").isAfter(interaction.headerInfo.startDate)
                || interaction.status === "AGREEMENT") {
                const newQuoteUrl: string = "/journey/init/product/" + productHelper.decodeShortenedProduct(interaction.product) + "/process/nb";

                return (
                    <RetrieveQuoteFailureMessagePage message={
                        <span>Your quote has expired.
                            <a href={newQuoteUrl} id="newQuote"> Start quote again</a>
                        </span>}/>
                );
            } else if (interaction.product === ProductsEnum.MOTOR.valueOf()) {
                return this.processMotorSubscriptionQuote(interaction);
            } else if (interaction.product === ProductsEnum.WOLF_MOTOR.valueOf()
                || interaction.product === ProductsEnum.HOME.valueOf()) {
                return this.processAnnualQuote(interaction);
            } else {
                return (
                    <Redirect to={"/journey/show/product/RentersInsurance/process/nb/quote/" + interaction._id}/>
                );
            }
        } else {
            return (
                <RetrieveQuoteFailureMessagePage message="Quote not found, please enter details again..."/>
            );
        }
    }

    private processMotorSubscriptionQuote(interaction: any) {
        if (interaction.status === "BINDING_QUOTE") {
            return (
                <Redirect to={"/journey/show/product/MotorInsurance/process/nb/summary/" + interaction._id}/>
            );
        } else if (interaction.status === "TEMP_INTERACTION" && interaction.source) {
            return (
                <Redirect to={"/journey/show/product/MotorInsurance/process/nb/gdprPage/" + interaction._id}/>
            );
        } else {
            return (
                <RetrieveQuoteFailureMessagePage message="Incorrect quote, please enter details again..."/>
            );
        }
    }

    private processAnnualQuote(interaction: any) {
        if (interaction.status === "BINDING_QUOTE" && (!interaction.source || (interaction.source === "ctm" && !interaction.clonedFrom))) {
            const page = interaction.product === ProductsEnum.WOLF_MOTOR.valueOf() ? "summary" : "quote";
            return (
                <Redirect
                    to={"/journey/show/product/" + interaction.product + "/process/nb/" + page + "/" + interaction._id}/>
            )
        } else {
            const aggErrorMessage = "Sorry, we can't retrieve your quote. This quote can only be retrieved from ";
            let quoteFailureMessage;

            switch (interaction.source) {
                case "ctm":
                case "ctmhome":
                    quoteFailureMessage = <>{aggErrorMessage} <a
                        href="https://comparethemarket.com">Comparethemarket.com</a></>;
                    break;
                case "cnf":
                case "cnfhome":
                    quoteFailureMessage = <>{aggErrorMessage} <a href="https://confused.com">Confused.com</a></>;
                    break;
                case "gc":
                case "gchome":
                    quoteFailureMessage = <>{aggErrorMessage} <a href="https://www.gocompare.com">Gocompare.com</a></>;
                    break;
                case "msm":
                case "msmhome":
                    quoteFailureMessage = <>{aggErrorMessage} <a
                        href="https://www.moneysupermarket.com/">MoneySuperMarket.com</a></>;
                    break;
                case "elx":
                    quoteFailureMessage = <>{aggErrorMessage} <a href="https://www.lvelectrix.co.uk/">ElectriX</a></>;
                    break;
                default:
                    quoteFailureMessage = "Quote not found, please enter details again...";
                    break;

            }

            return <RetrieveQuoteFailureMessagePage message={quoteFailureMessage}/>;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/quote/RetrieveQuotePage.tsx